<template>
	<inertia-head title="SAM Table" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">SAM Table</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Get the edge you need to become a successful long-term investor with SAM Table! Our comprehensive reference helps you make smarter decisions on what stocks to buy and when to buy them, without the guesswork and complexity. With our easy-to-use tool, you can quickly identify the best stocks and confidently invest for the future.
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">

		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<div v-if="user.current_rank === 'SILVER'">
					<div class="alert alert-warning">
						<p class="mb-0 fw-semibold">
							UPGRADE to GOLD or HIGHER to view SAM TABLE.
						</p>
					</div>
				</div>
				<div v-else>
					<span class="float-end text-end m-0">
						<button @click="setStockReminderModal.toggleModal" type="button" class="btn btn-sm btn-info"><i class="fa fa-clock me-1"></i>Set a Reminder</button>
					</span>
					<h4 class="content-heading fw-semibold fs-sm pt-1">
						Maximum Percentage:
						<small class="fs-sm">
							Distribute your money to various stocks. Don't put more than 10%
							or 20% of your total money in each stock.
						</small>
					</h4>
					<div class="row justify-content-center">
						<div class="col-sm-8">
							<VimeoIframe :videoLink="'https://player.vimeo.com/video/'+$page.props.samtable_vimeo_id+'?badge=0&autopause=0&player_id=0&app_id=58479'" />
						</div>
					</div>
					<div class="mt-5">
						<p class="fw-semibold mb-2">Last Updated: {{stocksBoss.length>0?stocksBoss[0].lasttradedate:''}}</p>
						<!-- <p class="fs-sm">The SAM table is updated every 30 minutes when the market is open.</p> -->
					</div>
					
					<div class="table-responsive">
						<div class="block-header block-header-default mt-4 fw-bold border h3 mb-0">BOSS (Bo's Strategic Stocks)</div>
						<DataTable 
						:data="stocksBoss" 
						:columns="tableColumns" 
						:options="{paging: false,info:false,searching:false}" 
						@click="rowClick"
						class="display table table-striped table-borderless table-hover table-vcenter fs-sm border">
					        <thead>
					            <tr>
									<th>Stocks</th>
									<th>Current Price</th>
									<th>Buy Below Price</th>
									<th>Target Price</th>
									<th>Expected Growth</th>
									<th>Max%</th>
									<th>Dividend Yield 25E%</th>
									<th>% From Target Price</th>
									<th>Action</th>
								</tr>
					        </thead>
					    </DataTable>

					    <div class="block-header block-header-default mt-5 fw-bold border h3 mb-0">Stocks with Bigger Cash Dividends</div>
						<DataTable 
						:data="stocks[2]" 
						:columns="tableColumns" 
						:options="{paging: false,info:false,searching:false}" 
						@click="rowClick"
						class="display table table-striped table-borderless table-hover table-vcenter fs-sm border">
					        <thead>
					            <tr>
									<th>Stocks</th>
									<th>Current Price</th>
									<th>Buy Below Price</th>
									<th>Target Price</th>
									<th>Expected Growth</th>
									<th>Max%</th>
									<th>Dividend Yield 25E%</th>
									<th>% From Target Price</th>
									<th>Action</th>
								</tr>
					        </thead>
					    </DataTable>


					    <div class="block-header block-header-default mt-5 fw-bold border h3 mb-0">Mature Stocks</div>
						<DataTable 
						:data="stocks[3]" 
						:columns="tableColumns" 
						:options="{paging: false,info:false,searching:false}" 
						@click="rowClick"
						class="display table table-striped table-borderless table-hover table-vcenter fs-sm border">
					        <thead>
					            <tr>
									<th>Stocks</th>
									<th>Current Price</th>
									<th>Buy Below Price</th>
									<th>Target Price</th>
									<th>Expected Growth</th>
									<th>Max%</th>
									<th>Dividend Yield 25E%</th>
									<th>% From Target Price</th>
									<th>Action</th>
								</tr>
					        </thead>
					    </DataTable>


					    <div class="block-header block-header-default mt-5 fw-bold border h3 mb-0">Young Growth Stocks</div>
						<DataTable 
						:data="stocks[4]" 
						:columns="tableColumns" 
						:options="{paging: false,info:false,searching:false}" 
						@click="rowClick"
						class="display table table-striped table-borderless table-hover table-vcenter fs-sm border">
					        <thead>
					            <tr>
									<th>Stocks</th>
									<th>Current Price</th>
									<th>Buy Below Price</th>
									<th>Target Price</th>
									<th>Expected Growth</th>
									<th>Max%</th>
									<th>Dividend Yield 25E%</th>
									<th>% From Target Price</th>
									<th>Action</th>
								</tr>
					        </thead>
					    </DataTable>

					    <div class="block-header block-header-default mt-5 fw-bold border h3 mb-0">REIT's</div>
						<DataTable 
						:data="stocks[5]" 
						:columns="tableColumnsFund" 
						:options="{paging: false,info:false,searching:false}" 
						@click="rowClick"
						class="display table table-striped table-borderless table-hover table-vcenter fs-sm border">
					        <thead>
					            <tr>
									<th>Code</th>
									<th>Fund Name</th>
									<th class="text-end">Action</th>
								</tr>
					        </thead>
					    </DataTable>


					    <div class="block-header block-header-default mt-5 fw-bold border h3 mb-0">Equity Funds</div>
						<DataTable 
						:data="stocks[6]" 
						:columns="tableColumnsFund" 
						:options="{paging: false,info:false,searching:false}" 
						@click="rowClick"
						class="display table table-striped table-borderless table-hover table-vcenter fs-sm border">
					        <thead>
					            <tr>
									<th>Code</th>
									<th>Fund Name</th>
									<th class="text-end">Action</th>
								</tr>
					        </thead>
					    </DataTable>


					    <div class="block-header block-header-default mt-5 fw-bold border h3 mb-0">Bonds</div>
						<DataTable 
						:data="stocks[7]" 
						:columns="tableColumnsFund" 
						:options="{paging: false,info:false,searching:false}" 
						@click="rowClick"
						class="display table table-striped table-borderless table-hover table-vcenter fs-sm border">
					        <thead>
					            <tr>
									<th>Code</th>
									<th>Fund Name</th>
									<th class="text-end">Action</th>
								</tr>
					        </thead>
					    </DataTable>

						<!-- <table class="table table-striped table-borderless table-hover table-vcenter fs-sm">
							<thead>
								<tr>
									<th>#</th>
									<th>Stocks</th>
									<th>Current Price</th>
									<th>Buy Below Price</th>
									<th>Target Price</th>
									<th>Expected Growth</th>
									<th>Max%</th>
									<th>% From Target Price</th>
									<th>Recommendation</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(stock, index) in stocks" :key="stock.stock">
									<td>{{ index + 1 }}</td>
									<td nowrap="">
										<inertia-link v-if="stock.has_details>0" href="#" @click="viewDetails(stock.stock)" class="fw-bold text-info" title="View the details">{{stock.stock}}</inertia-link>
										<inertia-link v-if="stock.has_details<=0" href="#" class="fw-bold text-secondary" title="No Details">{{stock.stock}}</inertia-link>
									</td>
									<td>{{ stock.tradeprice }}</td>
									<td>{{ stock.buybelowprice }}</td>
									<td>{{ stock.targetprice }}</td>
									<td>{{ stock.expected_growth }}%</td>
									<td>{{ stock.maxperc }}%</td>
									<td>{{ stock.target_perc }}%</td>
									<td class="text-end fw-semibold"
										:class="
											stock.actiontotake === 'Continue Buying'
												? 'text-success'
												: stock.actiontotake === 'Stop Buying'
												? 'text-danger'
												: stock.actiontotake === 'Hold'
												? 'text-warning'
												: stock.actiontotake === 'Sell'
												? 'text-elagance'
												: 'text-secondary'
										"
									>
										<small>{{ stock.actiontotake }}</small>
									</td>
								</tr>
								<tr v-if="stocks.length == 0">
									<td colspan="9">
										<p class="m-2 fw-semibold text-center text-danger">NO RECORD FOUND</p>
									</td>
								</tr>
							</tbody>
						</table> -->
					</div>

					<div class="my-5">
						<div class="input-group">
							<input type="text" v-model="search" name="search" placeholder="Search" class="form-control" />
							<button type="button" @click="searchStock()" name="btnsearch" class="btn btn-outline-info"><i class="fa fa-search me-1"></i>Search</button>
						</div>
						<div class="my-2">
							
							<div class="table-responsive">
								<table class="table table-striped table-borderless table-vcenter fs-sm">
									<thead>
										<tr>
											<th>Stock</th>
											<th class="text-end">:::</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(stock, index) in stocksInactive" :key="stock.stock">
											<td nowrap="">
												<span class="fw-bold">{{stock.stock}}</span>
											</td>
											<td class="text-end">
												<button v-if="stock.has_details" type="button" @click="viewDetails(stock.stock)" class="btn btn-sm btn-outline-info" title="View Details"><i class="fa fa-search"></i></button>
												<button v-else type="button" class="btn btn-sm btn-outline-info disabled" title="Disabled View Details"><i class="fa fa-search"></i></button>
											</td>
										</tr>
										<tr v-if="stocksInactive.length == 0">
											<td colspan="3">
												<p class="m-2 fw-semibold text-center text-danger">NO RECORD FOUND</p>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

						</div>
					</div>

				</div>
			</div>
		</div>

		<set-stock-reminder-modal
		ref="setStockReminderModal"
		:stockReminders="stockReminders"
		:rank-prefix="rank_prefix"
		@changeAction="changeAction"
		></set-stock-reminder-modal>

		<recommendations-modal
		ref="recommendationsModal"
		:stockDetails="stockDetails"
		></recommendations-modal>

	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);
	
import debounce from 'lodash/debounce'
import { onMounted, ref, watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import AuthLayout from '../../../Layouts/AuthLayout'
import SetStockReminderModal from '../../../Components/Member/SetStockReminderModal'
import RecommendationsModal from '../../../Components/Member/RecommendationsModal';
import { createToaster } from '@meforma/vue-toaster';
import DataTable from 'datatables.net-vue3';
import DataTablesLib from 'datatables.net';

export default {
	layout: AuthLayout,
	props: {
		user			: Object,
		rank_prefix 	: String,
		stocksBoss 		: Array,
		stocks 			: Object,
		stocksInactive 	: Array,
		stockDetails	: Object,
		stockReminders 	: Object,
		filters 		: Object,
		errors 			: Object,
		api_response 	: Object
	},
	components:{SetStockReminderModal,RecommendationsModal,DataTable},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const action 				= ref('add');
		const search 				= ref(props.filters.search);
		const query 				= ref(props.filters.query);

		DataTable.use(DataTablesLib);

		const tableColumns = [
			// {
			// 	data: 'cnt',
			// 	render:(val,type,data)=>{
			// 		return (val+1);
			// 	}
			// },
			{
				data: 'stock',
				render:(val,type,data)=>{
					var color = "text-secondary";
					// console.log(data);
					var id = "";
					var detail_title = "No Stock Details";
					var has_details = data.has_details;

					if(has_details>0)
					{
						color 			= "text-info";
						id 				= "viewable";
						detail_title 	= "View Stock Details";
					}

					return '<a id="'+id+'" href="javascript:void(0)" class="fw-bold '+color+'" title="'+detail_title+'">'+val+'</a>';
				}
			},
			{data: 'tradeprice'},
			{data: 'buybelowprice'},
			{data: 'targetprice'},
			{data: 'expected_growth'},
			{data: 'maxperc'},
			{data: 'dividend_yield_25e'},
			{data: 'target_perc'},
			{
				data: 'actiontotake',
				render: (data)=>{
					var style = "";
					if(data=='Continue Buying')
					{
						style="text-success";
					}else if(data=='Stop Buying'){
						style="text-danger";
					}else if(data=='Hold'){
						style="text-warning";
					}else if(data=='Sell'){
						style="text-elagance";
					}else{
						style="text-secondary";
					}

					return '<span class="fw-semibold '+style+'">'+data+'</span>';
				}
			},
		];


		const tableColumnsFund = [
			{
				data: 'stock',
				render:(val,type,data)=>{
					var color = "text-secondary";
					// console.log(data);
					var id = "";
					var detail_title = "No Stock Details";
					var has_details = data.has_details;

					if(has_details>0)
					{
						color 			= "text-info";
						id 				= "viewable";
						detail_title 	= "View Stock Details";
					}

					return '<a id="'+id+'" href="javascript:void(0)" class="fw-bold '+color+'" title="'+detail_title+'">'+val+'</a>';
				}
			},
			{data: 'stock_name'},
			{
				data: 'actiontotake',
				render: (data)=>{
					var style = "";
					if(data=='Continue Buying')
					{
						style="text-success";
					}else if(data=='Stop Buying'){
						style="text-danger";
					}else if(data=='Hold'){
						style="text-warning";
					}else if(data=='Sell'){
						style="text-elagance";
					}else{
						style="text-secondary";
					}

					return '<span class="fw-semibold '+style+' float-end">'+data+'</span>';
				}
			},
		];


		const rowClick = (item)=>{
			if(item.target.id=='viewable')
			{
				viewDetails(item.target.innerText);
			}
			
		}

		const setStockReminderModal = ref(null);
		const recommendationsModal 	= ref(null);

		const per_page = ref(props.filters.per_page ?? 25);

		const changeAction =(value)=>{
			action.value = value;
		}

		const searchStock = ()=>{
			Inertia.get(
				'/member/recommendations/sam?search='+search.value,{},
				{
					// replace: true,
					preserveState: true,
					preserveScroll: true,
					only:['stocksInactive','filters']
				}
			)
		}

		const viewDetails = (_stock)=>{

			Inertia.get(
				'/member/recommendations/sam?stock='+_stock,{},
				{
					// replace: true,
					preserveState: true,
					preserveScroll: true,
					only:['stockDetails']
				}
			)

			recommendationsModal.value.toggleModal();
		}

		// watch(
		// 	query,
		// 	function (value) {
		// 		var param = { per_page : per_page.value };

		// 		if(value!='')
		// 		{
		// 			param.query = value;
		// 		}

		// 		Inertia.get(
		// 			'/member/my-materials/sam-table',
		// 			param,
		// 			{
		// 				// replace: true,
		// 				preserveState: true,
		// 				preserveScroll: true,
		// 				only: ['stocks', 'filters']
		// 			}
		// 		)
		// 	}
		// )

		// watch(per_page, (value) => {
		// 	var param = { per_page : value };

		// 	if(query.value!='')
		// 	{
		// 		param.query = query.value;
		// 	}

		// 	Inertia.get(
		// 		'/member/my-materials/sam-table', param,
		// 		{
		// 			// replace: true,
		// 			preserveState: true,
		// 			preserveScroll: true,
		// 			only: ['stocks', 'filters']
		// 		}
		// 	)
		// })

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='update' ? 'updated' : (action.value=='delete' ? 'deleted' : 'added');

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else if(value.result=="exceed")
				{
					toast.show(value.data, { type: "error"});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "error"});
				}
			}
		})

		return {
			action,
			changeAction,
			rowClick,
			search,
			query,
			per_page,
			tableColumns,
			tableColumnsFund,
			searchStock,
			viewDetails,
			setStockReminderModal,
			recommendationsModal
		}
	},
}
</script>

<style>
	.dataTables_empty{
		text-align: center;
	}
</style>